

export const SERVER_URL = "https://kit-id-gen.viome.com/";
export const VIOME_AUTH_URL = "https://kit-id-gen.viome.com/app/authenticate/credentials";
//APPLICATION URLS

//LOCAL DEV TESTING

//const SERVER_URL = "http://localhost:9040/";

const VIOME_APP_URL =  SERVER_URL + "spectrum/";

const ADMIN_URL = "admin";
const USER_URL = "user";
export const VALIDATE_REQUEST_URL = VIOME_APP_URL + "validate";
export const GENERATE_DOWNLOAD_URL = VIOME_APP_URL + "download";
export const SHOW_GENERATE_HISTORY = VIOME_APP_URL + USER_URL  + "/history";
export const GENERATE_EMAIL_URL = VIOME_APP_URL + "email";
export const SEARCH_URL = VIOME_APP_URL + "search";
export const PRODUCT_ID_END_POINT = SEARCH_URL + "/id";
export const CREATED_BY_END_POINT = SEARCH_URL + "/author";
export const CREATED_DATE_END_POINT = SEARCH_URL + "/date";
export const CREATED_DATE_RANGE_END_POINT = SEARCH_URL + "/daterange";
export const CSV_FILE_DOWNLOAD_END_POINT = SEARCH_URL + "/download";

export const LOAD_VIOME_KITS_URL = VIOME_APP_URL + ADMIN_URL + "/loadKits";
export const LOAD_VIOME_TESTS_URL = VIOME_APP_URL + ADMIN_URL + "/loadTests";

export const CREATE_VIOME_KIT_URL = VIOME_APP_URL + ADMIN_URL + "/kit/create";
export const DELETE_VIOME_KIT_URL = VIOME_APP_URL + ADMIN_URL + "/kit/remove";
export const UPDATE_VIOME_KIT_URL = VIOME_APP_URL + ADMIN_URL + "/kit/update";

export const CREATE_VIOME_TEST_URL =
  VIOME_APP_URL + ADMIN_URL + "/kit/test/create";
export const DELETE_VIOME_TEST_URL =
  VIOME_APP_URL + ADMIN_URL + "/kit/test/delete";
export const UPDATE_VIOME_TEST_URL =
  VIOME_APP_URL + ADMIN_URL + "/kit/test/update";
